module.exports = __webpack_public_path__ + "static/BOTLogoWithText-8c8142452cae286aaff3cabd4c5dbbd7.png";